enum SUPPORTED_BRANDS {
  ATP = 'atp',
  // SWA = 'swa',
}

export default SUPPORTED_BRANDS;
